// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"4b525ddc","879":"163dbe72"}[chunkId] + ".chunk.js";
};